/**
 * `/live-chat`: the header, a "Live Chat" heading and the footer. It has no other content. Nothing
 * in this repository links to it. The chat itself is the `window.LiveChatWidget` that pages open
 * with `LiveChatWidget.call("maximize")` (for example
 * `components/Shared/ContactUsRefactor/Shared/ContactCard.tsx`); no file here loads that widget.
 *
 * The page is a leftover: it does nothing for a visitor, so it is dead code under web-architecture
 * ADR-0019. The static export still builds it.
 */
import React from "react";
import { ContentSection } from "@ryerson/frontend.layout";
import { Typography } from "@ryerson/frontend.typography";
import { allContentfulHeaderCalls, HeaderPageProps } from "@ryerson/frontend.contentful";
import { getHeaderData } from "@components/NextLayouts/nextUtilities";
import HeaderLayout from "@components/NextLayouts/HeaderLayout";

/** Fetches only the Contentful header, locations and footer data that `HeaderLayout` needs. */
export const getStaticProps = async () => {
	return await allContentfulHeaderCalls();
};

/** The `/live-chat` page; see the file header. */
const Page: React.FC<HeaderPageProps> = (props) => {
	return (
		<HeaderLayout {...getHeaderData(props)}>
			<ContentSection>
				<Typography variant="h1">Live Chat</Typography>
			</ContentSection>
		</HeaderLayout>
	);
};

export default Page;
